import styled, { css } from 'styled-components';
import { Scalars } from '@bechtel/types';
import { ModalBackdropStyled, Box } from '@bechtel/gds';

export const listWidth = '392px';
export const smallScreenListWidth = '344px';

const drawerWidth = '288px';

interface ScreenListWidthTypeProps {
  type?: Scalars['Boolean'];
}

const getScreenLeftSize = (props: ScreenListWidthTypeProps) => {
  if (props.type) {
    return css`
      left: 0;
    `;
  } else {
    return css`
      left: ${listWidth};
    `;
  }
};
const getSmallScreenLeftSize = (props: ScreenListWidthTypeProps) => {
  if (props.type) {
    return css`
      left: auto;
    `;
  } else {
    return css`
      left: ${smallScreenListWidth};
    `;
  }
};
const getDrawerAlignment = (props: ScreenListWidthTypeProps) => {
  if (props.type) {
    return css`
      left: auto;
      right: 0;
    `;
  } else {
    return css`
      left: 0;
    `;
  }
};
const getDrawerBorder = (props: ScreenListWidthTypeProps) => {
  if (props.type) {
    return css`
      border-bottom-right-radius: ${({ theme }) => theme.radii[400]};
      border-top-right-radius: ${({ theme }) => theme.radii[400]};
    `;
  } else {
    return css``;
  }
};
export const DrawerBackdropStyled = styled(ModalBackdropStyled)<ScreenListWidthTypeProps>`
  position: absolute;
  border-radius: ${({ theme }) => theme.radii[400]};
  ${getScreenLeftSize};

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${getSmallScreenLeftSize};
  }
`;

export const DrawerOuterStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })<ScreenListWidthTypeProps>`
  background-color: ${({ theme }) => theme.colors.white};
  height: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: ${drawerWidth};
  ${getDrawerAlignment}
  ${getDrawerBorder}
`;
